var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoLightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2C10.058 2 2 10.058 2 20s8.058 18 18 18 18-8.058 18-18S29.942 2 20 2zm0 33.75c-8.684 0-15.75-7.066-15.75-15.75 0-8.684 7.066-15.75 15.75-15.75 8.684 0 15.75 7.066 15.75 15.75 0 8.684-7.066 15.75-15.75 15.75zm0-20.813a1.688 1.688 0 100-3.375 1.688 1.688 0 000 3.376zm3.375 11.813h-2.25v-7.875c0-.619-.506-1.125-1.125-1.125h-2.25c-.619 0-1.125.506-1.125 1.125S17.131 20 17.75 20h1.125v6.75h-2.25c-.619 0-1.125.506-1.125 1.125S16.006 29 16.625 29h6.75a1.125 1.125 0 000-2.25z"
  })));
}
export default SvgInfoLightCircle;